const calculateWTax = ({ vatType, wTaxRate, subTotalGrossPrice }) => {
  const vatRate = vatType === 'None IVAT-X1' ? 0 : 0.12
  const wTax = 0.01 * parseInt(wTaxRate)
  const unitPrice = subTotalGrossPrice / (1 + vatRate)
  const withholdingTax = unitPrice * wTax
  return withholdingTax
}

export const calculateTotalWTax = projectClasses => {
  const wTaxAmounts = []
  for (const obj of projectClasses) {
    wTaxAmounts.push(
      calculateWTax({
        vatType: obj.vatType,
        wTaxRate: obj.wTaxRate,
        subTotalGrossPrice: obj.subTotalGrossPrice
      })
    )
  }
  return wTaxAmounts.reduce((a, b) => a + b, 0).toFixed(2)
}

export default calculateWTax
